module.exports = __webpack_public_path__ + "img/IN.ef9cea48.svg";